import { render, staticRenderFns } from "./Territory.vue?vue&type=template&id=637b69be&scoped=true"
import script from "./Territory.vue?vue&type=script&lang=js"
export * from "./Territory.vue?vue&type=script&lang=js"
import style0 from "./Territory.vue?vue&type=style&index=0&id=637b69be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b69be",
  null
  
)

export default component.exports